import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
//import FooterCopyright from "../../components/footer/FooterCopyright";
//import FooterNewsletter from "../../components/footer/FooterNewsletter";
import { multilanguage } from "redux-multilanguage";
const FooterOne = ({
  strings,
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <footer
      className={`footer-area ${
        backgroundColorClass ? backgroundColorClass : ""
      } ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      } ${extraFooterClass ? extraFooterClass : ""} ${
        spaceLeftClass ? spaceLeftClass : ""
      } ${spaceRightClass ? spaceRightClass : ""}`}
    >
      <div className={`${containerClass ? containerClass : "container"}`}>
        <div className="row">

          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-6" : "col-lg-4 col-md-4 col-sm-6"
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3>{strings["support"]}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    {strings["company_name"]}
                  </li>
                  <li>
                    <a href='callto:85226042833'>
                    <i className="fa fa-phone" />&nbsp;&nbsp;(852) 2604 2833
                    </a>
                  </li>
                  <li>
                    <a href='mailto:info@whmsl.com.hk'>
                    <i className="fa fa-envelope"/>&nbsp;&nbsp;info@whmsl.com.hk
                    </a>
                  </li>
                  <li>
                    <a href='https://api.whatsapp.com/send?phone=85291466835'>
                    <i className="fa fa-whatsapp"/>&nbsp;&nbsp;(852) 9146 6835
                    </a>
                  </li>                 
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-6" : "col-lg-4 col-md-4 col-sm-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">
                <h3>{strings["useful_links"]}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/Delivery"}>{strings["delivery_policy"]}</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/Payment"}>
                      {strings["payment_methods"]}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/Return"}>{strings["return_policy"]}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-6" : "col-lg-4 col-md-4 col-sm-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-145"
                  : "footer-widget mb-30 ml-75"
              }`}
            >
              <div className="footer-title">
                <h3>{strings["follow_us"]}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/winghangmedical"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/winghangmedicalsupplies"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                {/*  <li>
                    <a
                      href="/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Youtube
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="footer-border container">
      <div className="row">
      <div className="col-lg-6 col-md-7">
      <div className="footer-bottom text-left">
          <div
            className="copyrightColorClass"
          >
            <p>
              © 2023{" "}
              <a
                href="//www.cosso.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                Cosmo Solution Ltd.
              </a>
              . All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
      <div className="footer-payment col-lg-6 col-md-5">
       <img className="payment-img"
       src="/assets/img/payment/mastercard.svg"
       alt=""
       />      
       <img className="payment-img"
       src="/assets/img/payment/visa.svg"
       alt=""
       />     
       <img className="payme-img"
       src="/assets/img/payme/payme-logo-red.png"
       alt=""
       />         
       <img className="payment-img"
       src="/assets/img/payment/applepay.svg"
       alt=""
       />        
       <img className="payment-img"
       src="/assets/img/payment/google-pay.svg"
       alt=""
       />        
       <img className="payment-img"
       src="/assets/img/payment/fps_color.svg"
       alt=""
       />         
      </div>
      </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
  strings: PropTypes.object
};

export default multilanguage(FooterOne);
